import BN from 'bignumber.js';

// for BigNumber type { _hex: 0x00, _isBigNumber: true }
export function bigIntToFloatString(bigN: BN, decimals: number) {
  const denom = new BN(10).pow(decimals);
  const floatString = bigN.dividedBy(denom).toString();

  return floatString;
}
